/*
 *
 *@description:  通用弹窗组件
 *@modifyContent:
 *@author: qiuhongyang
 *@date: 2020-09-22 09:52:23
 *
*/


import dot from "dot";
let tpl = require("./smallmodal.html");
import './smallmodal.less';


interface obj {
  [index: string]: any
};

let warmming = {
  options: {
    subcallback: Function  //提交回调
  },
  init(opt: any) {
    let defaultopt = {
      content: "",
      boxid:"",
      callback: null,
      showtime: 3000,
      showwarmicon: true,
      width: 298,
      height: 218,
      tipinfos: '',
      subtext: "确定",
      iconname: "icon_sub",
      showsubbtn: true,
      showcancelbtn: true

    };
    this.options = $.extend({}, defaultopt, opt);

    let htmlstr = dot.template(tpl)(this.options)
    $(opt.boxid).append($(htmlstr));
    this.bindevent();
  },
  bindevent() {
    let that = this;
    $(".modal_shadow").on('click', function () {
      $("._smallmodal_toast").remove()
    })

    $(".sure_btn").on('click', function () {
      let subcallback = that.options.subcallback;
      if (subcallback) { subcallback() };
      $("._smallmodal_toast").remove();
      return false;
    })

    $(".modalbtn_cancel").on('click', function () {
      $("._smallmodal_toast").remove();
      return false;
    })
  }
}



export default warmming